import React from "react";

const PrimaryButton = ({ text, icon, ...props }) => {
  return (
    <button className="primary-btn" {...props}>
      {icon && icon}
      <p className="primary-btn-text">{text}</p>
    </button>
  );
};

export default PrimaryButton;
